import {Icon, LinkText} from '@/components/atoms'
import {DynamicColumnTable} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {useSalesTargets} from '@/hooks/useSalesTargets'
import {getSelectedRowData} from '@/utils/commons'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

// eslint-disable-next-line react-refresh/only-export-components
export const cellDataMapperObj = navigate => ({
  salesTargetName: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText
          text={original?.salesTargetName}
          id={original?.salesTargetName + ' ' + original?.id}
          handleClick={() => {
            navigate(`/rewards/sales-target-detail/${original?.id}`)
          }}
        />
      </div>
    )
  },
  numEligibleStores: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.numEligibleStores}</div>
  },
  percentageAchievedTarget: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.percentageAchievedTarget}</div>
  },
  pointsAwarded: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.pointsAwarded}</div>
  },
  status: ({row: {original} = {}}) => {
    return <div className={original?.status === 'Error' ? 'status_error' : ''}>{original?.status}</div>
  },
  report: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText text={original?.report} id={original?.id} handleClick={() => {}} />
      </div>
    )
  },
})

export const SalesTargetList = () => {
  const navigate = useNavigate()

  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  const {salesTargetsData, salesTargetsColConfigData, setPageIndex, setSortingObj, setSearchArry, onDownloadBtnClick} =
    useSalesTargets()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), salesTargetsColConfigData)
  const selectedDataList = getSelectedRowData(rowSelected, salesTargetsData?.data)

  const extractIds = () => (isSelectAll ? [] : selectedDataList?.map(item => item.id))

  const onDownloadClick = async () => {
    onDownloadBtnClick(extractIds(), isSelectAll)
  }

  return (
    <div className="salesTargetsDataTable">
      <DynamicColumnTable
        pageSize={50}
        columns={cellDataMappedCols || []}
        records={salesTargetsData?.data || []}
        rowSelection={rowSelected}
        setRowSelection={setRowSelected}
        toolbarActions={[
          {
            iconLeading: <Icon icon="download" size="small" />,
            text: 'Download',
            variant: 'secondary',
            onClick: () => {
              onDownloadClick()
            },
          },
        ]}
        setPageIndex={setPageIndex}
        setSearchArry={setSearchArry}
        setSortingObj={setSortingObj}
        setIsSelectAll={setIsSelectAll}
      />
      {salesTargetsData?.totalRecords && (
        <div className="txtRightAlign">{salesTargetsData?.totalRecords} total items</div>
      )}
    </div>
  )
}
